module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 171.74a5f57e.png";